export default __webpack_public_path__ + "static/media/loader.0e36a9d3.svg";